import styled from 'styled-components';

export const FieldLabelSC = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  /* identical to box height, or 100% */
  color: #333d6c;
  height: 12px;
  margin: 0;
  margin-bottom: 5px;
  display: inline-block;
`;
